import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import filterUrlQueryParams from '@utils/filterUrlQueryParams';

import useSortableGrid from '@modules/sortable-grid/composables/useSortableGrid';

/**
 *
 * @returns {{getPageLinkUrl: (pageNumber: number)=>string}}
 */
export default function useNumericPaginationItem() {
  const route = useRoute();
  const store = useStore();

  const { generateUrlPathAndQuery } = useSortableGrid();

  /**
   *
   * @param {number} pageNumber
   * @returns {string}
   */
  const getPageLinkUrl = (pageNumber) => {
    const paginationDataCopy = [...store.getters.getPathUrls];
    const foundIndex = paginationDataCopy.findIndex((item) => item.key === 'Pageindex');

    // Pageindex only gets added if page higher than 1
    /* istanbul ignore else */
    if (pageNumber > 1) {
      if (foundIndex < 0) {
        // If Pageindex is not part of, adds it
        paginationDataCopy?.push({ key: 'Pageindex', value: pageNumber });
      } else {
        // If already part of paginationData, replaces the value with the pageNumber
        paginationDataCopy[foundIndex].value = pageNumber;
      }
      // If first page, Pageindex is not added as default
    } else if (pageNumber === 1 && foundIndex >= 0) {
      delete paginationDataCopy[foundIndex];
    }

    const { pathname } = generateUrlPathAndQuery(paginationDataCopy, route);

    return filterUrlQueryParams(pathname);
  };

  return {
    getPageLinkUrl,
  };
}
